<ngb-accordion #a="ngbAccordion" class="border rounded">
  <ngb-panel id="tagDropdown">
    <ng-template ngbPanelHeader let-opened="opened">
      <div class="l_flexbar">
        <!-- The entire section should be clickable-->
        <button
          ngbPanelToggle
          class="btn-link guts-p-v-3 full-width h3"
          data-dgat="tag-dropdown-d15"
          [attr.aria-label]="sectionTitle"
          [attr.aria-expanded]="opened"
        >
          {{ sectionTitle }}
          <df-icon
            [icon]="opened ? 'chevron-up' : 'chevron-down'"
            class="color-ebony-a61 header-icon guts-p-r-3 guts-m-r-2 panel__dropdown-icon"
            size="medium"
          ></df-icon>
        </button>
      </div>
    </ng-template>
    <ng-template ngbPanelContent>
      <div>
        <ul class="inline-list">
          <li
            *ngFor="let skill of skills"
            class="guts-m-r-1 guts-m-b-1"
            data-dgat="tag-dropdown-bb3"
          >
            <button
              df-button
              type="button"
              class="btn btn__toggle"
              [ngClass]="{
                'df-button-primary': skill.selected,
                'df-button-secondary': !skill.selected
              }"
              (click)="onToggleSkill(skill)"
              role="checkbox"
              [attr.aria-checked]="skill.selected"
              data-dgat="tag-dropdown-162"
            >
              <!-- a new Fresco action button coming in Future will
             replace need for v-bottom on these action buttons -->
              <df-icon
                *ngIf="skill.selected"
                icon="checkmark"
                size="medium"
                class="v-bottom"
              ></df-icon>
              {{ skill.name | titlecase }}
            </button>
          </li>
        </ul>
      </div>
    </ng-template>
  </ngb-panel>
</ngb-accordion>
